import React from 'react';
import "./index.css";

export const SignUp = () => {
  return (
    <div className='signUpBanner'>
        <div className='signGrid container'>
            <div className='signUPLeft'>
                <div  className='signLeftContent'>
                <div className='signTitle'>SnapBid</div>
                <div className='signSubTitle'>
                    <span>Start Your Property Journey with SnapBid</span>
                    <span>We verify every account to keep bidding fair and transparent.</span>
                </div>
                <form>
                    <div className='signInput'>
                        <label>Full Name <span className='text-danger'>*</span></label>
                       <div> <input type="text" placeholder='eg: andrew'/></div>

                    </div>
                    <div className='signSubGrid'>
                      <div className='signInput'>
                        <label>Email<span className='text-danger'>*</span></label>
                       <div> <input type="email" placeholder='eg: andrew123@gmail.com'/></div>

                    </div>
                    <div className='signInput'>
                        <label>Mobile Number<span className='text-danger'>*</span></label>
                       <div> <input type="text" placeholder='eg: 8523697410'/></div>

                    </div>

                    </div>
                    <div className='signSubGrid'>
                      <div className='signInput'>
                        <label>Aadhaar Number<span className='text-danger'>*</span></label>
                       <div> <input type="text" placeholder='eg: 1234 4567 7896'/></div>

                    </div>
                    <div className='signInput'>
                        <label>PAN Number<span className='text-danger'>*</span></label>
                       <div> <input type="text" placeholder='eg: FPRTR1234F'/></div>

                    </div>

                    </div>
                     <div className='signSubGrid'>
                      <div className='signInput'>
                        <label>Create Password<span className='text-danger'>*</span></label>
                       <div> <input type="password" placeholder='Enter New Password'/></div>

                    </div>
                    <div className='signInput'>
                        <label>Confirm Password<span className='text-danger'>*</span></label>
                       <div> <input type="password" placeholder='Re-Enter Password'/></div>

                    </div>

                    </div>
                     <div className='signInput'>
                        <label>Interested In <span className='text-danger'>*</span></label>
                        <div><input type="text" placeholder='Select'/></div>

                    </div>
                    
                    <div className='btnSign'><button>Create Account</button></div>
                    <div className='textDont'>Already have an account? <span ><a href='/' style={{color:'#2E5B3D',textDecoration:'none'}}>Sign In</a></span></div>

                </form>
                <div className='noteContainer'>
                  <div>Note:</div>
                  <div>To ensure genuine participation and prevent duplicate accounts, government ID verification is required. Your data is securely encrypted and never shared.</div>
                </div>

            </div>
            </div>
            <div className='signRight'>
                <div>Your Next Property Starts Here!</div>
                <div>Verified listings. Real buyers. Zero blind bidding.</div>
            </div>

        </div>
    </div>

   
  )
}
